export default {"src":"/_next/static/media/2026_winner.4432944b.svg","height":84,"width":188,"blurWidth":0,"blurHeight":0};